import { PeriodType, PeriodTypeQuery, PeriodTypeView } from "@/types"

export type ReducerState = {
  period: PeriodType
  view: PeriodTypeView
  queryPeriod: PeriodTypeQuery
}

function createAction<T extends keyof ReducerState>({
  type,
  payload,
}: {
  type: string
  payload: ReducerState[T]
}) {
  return { type, payload }
}
export function switchPeriod(period: PeriodType) {
  return createAction({ type: `switchPeriod` as const, payload: period })
}

export function switchView(view: PeriodTypeView) {
  return createAction({ type: `switchView` as const, payload: view })
}

export function switchQueryPeriod(queryPeriod: PeriodTypeQuery) {
  return createAction({
    type: `switchQueryPeriod` as const,
    payload: queryPeriod,
  })
}

export type PageReducerAction = ReturnType<
  typeof switchPeriod | typeof switchView | typeof switchQueryPeriod
>

export const reducer = (
  state: ReducerState,
  action?: PageReducerAction
): ReducerState => {
  if (!action) return state
  switch (action.type) {
    case `switchPeriod`:
      return { ...state, period: action.payload as PeriodType }
    case `switchView`:
      return { ...state, view: action.payload as PeriodTypeView }
    case `switchQueryPeriod`:
      return { ...state, queryPeriod: action.payload as PeriodTypeQuery }
    default:
      return state
  }
}
